import Tippy from '@tippy.js/react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconInfo from 'svgIcons/MotionPortalIcons/IconInfo';

const InfoButton = (props) => {
    const { kpi } = props;
    const { t: translate } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsVisible(false);
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, []);

    return <>
        {kpi.measurementTypeDescription ? <Tippy
            content={translate(kpi.measurementTypeDescriptionKey) || kpi.measurementTypeDescription}
            interactive={true}
            interactiveBorder={10}
            animation='scale'
            theme='light-border'
            trigger='click'
            visible={isVisible}
            onClickOutside={() => setIsVisible(false)}
            placement='left'
        >
            <button type='button' onClick={(event) => { event.stopPropagation(); setIsVisible(v => !v); }}>
                <IconInfo />
            </button>
        </Tippy> : null
        }
    </>;
};

InfoButton.propTypes = {
    kpi: PropTypes.object
};

export default InfoButton;
